export default __webpack_public_path__ + "static/media/success.c265a5b6.png";